export default __webpack_public_path__ + "static/media/BYD_DS-E.7fa61309.jpg";